import axios from 'axios';
import * as util from "@/utilities/util.js";


export async function uploadFileToIPFS(formData) {
    console.log('Pinata API Key:', util.PINATA_API_KEY ? 'SET (' + util.PINATA_API_KEY.substring(0, 4) + '...)' : 'UNDEFINED');
    console.log('Pinata Secret:', util.PINATA_SECRET_KEY ? 'SET (' + util.PINATA_SECRET_KEY.substring(0, 4) + '...)' : 'UNDEFINED');
    return await axios.post(util.API.pinFileToIPFS, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'pinata_api_key': util.PINATA_API_KEY,
            'pinata_secret_api_key': util.PINATA_SECRET_KEY
        }
    })
}

export async function uploadJsonToIPFS(metadata) {
    return axios.post(util.API.pinJSONToIPFS, JSON.stringify(metadata), {
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'pinata_api_key': util.PINATA_API_KEY,
            'pinata_secret_api_key': util.PINATA_SECRET_KEY
        },
    })
}